// extracted by mini-css-extract-plugin
module.exports = {"events":"styles_events__2jNuH","eventEditor":"styles_eventEditor__O-DS7","eventTitle":"styles_eventTitle__3emnO"};